import Icon from '../components/Icon.vue'

Icon.register({
  crow: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M544 32H527.6C513 12.7 490.1 0 464 0 419.8 0 384 35.8 384 80V101L12.1 393.6A30.2-30.2 0 0 1 0 417.7C0 440.2 23.6 454.8 43.7 444.8L165.3 384H261.8L306.2 504.1C308.4 510.3 315.3 513.5 321.6 511.3L344.1 503.1C350.3 500.8 353.5 493.9 351.3 487.7L312.9 384H352C353.9 384 355.8 383.8 357.7 383.7L402.2 504.1C404.4 510.3 411.3 513.5 417.6 511.3L440.1 503.1C446.3 500.8 449.5 493.9 447.3 487.7L406 376.1C485.7 352.8 544 279.3 544 192V112L640 96C640 60.6 597 32 544 32zM464 104C450.8 104 440 93.3 440 80 440 66.7 450.8 56 464 56S488 66.7 488 80C488 93.3 477.3 104 464 104z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/crow.js
// module id = f5ca
// module chunks = 144